import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-799d93ec"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "header" };
const _hoisted_2 = { class: "header__inner" };
const _hoisted_3 = { class: "flex-1 header__title" };
const _hoisted_4 = { class: "md:flex md:flex-row space-x-4 flex-none" };
const _hoisted_5 = { class: "flex-1" };
import { PlusIcon, SearchIcon } from "@heroicons/vue/outline";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import { useRoute } from "vue-router";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        createRouteName: { default: undefined },
        searchQuery: { default: "" },
        pageTitle: { default: undefined }
    },
    emits: ["update:searchQuery"],
    setup(__props, { emit }) {
        const props = __props;
        const route = useRoute();
        const title = computed(() => route.name?.toString().replace(/\.?list\.?/i, "") ?? "");
        const genTitle = computed(() => `${title.value.charAt(0).toUpperCase()}${title.value.substring(1)}`);
        const searchQuery = ref(props.searchQuery);
        watch(searchQuery, (query) => emit("update:searchQuery", query));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "title", {}, () => [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(props.pageTitle ? props.pageTitle : _unref(genTitle)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _renderSlot(_ctx.$slots, "filters", {}, () => [
                                _createVNode(Input, {
                                    placeholder: "Search...",
                                    modelValue: searchQuery.value,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchQuery).value = $event))
                                }, {
                                    icon: _withCtx(() => [
                                        _createVNode(_unref(SearchIcon), { class: "icon" })
                                    ]),
                                    _: 1
                                }, 8, ["modelValue"])
                            ])
                        ]),
                        (props.createRouteName && _ctx.$slots['filters:menu'])
                            ? (_openBlock(), _createBlock(Button, {
                                key: 0,
                                to: { name: props.createRouteName },
                                variant: "dark"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_unref(PlusIcon), { class: "icon" })
                                ]),
                                _: 1
                            }, 8, ["to"]))
                            : _createCommentVNode("", true)
                    ])
                ])
            ]));
        };
    }
});
